<template>
  <div>

    <div class="row">
      <div class="col-12 col-xl-10 offset-xl-1">

        <div v-if="($root.getLoggedUser() && !$root.getLoggedUser().has_verified_email)" class="row">
          <div class="col-12">
            <div class="alert alert-danger alert-with-icon mt-3">
              <span class="ti-alert" data-notify="icon"></span>
              <div data-notify="message">
                <div>Your email address is pending verification. You need to verify your email in order to perform any action</div>
                <div><u class="pointer" @click="sendVerificationEmail">Send verification link again<span v-if="sendingVerificationEmail">...</span></u></div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="($root.getLoggedUser() && !$root.getLoggedUser().is_verified)" class="row">
          <div class="col-12">
            <div class="alert alert-danger alert-with-icon mt-3">
              <span class="ti-alert" data-notify="icon"></span>
              <div data-notify="message">
                <div>Your account is pending verification by our team</div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <span class="ti-search"></span>
              </span>
            </div>
            <input class="form-control" type="text" v-model.trim="searchCompaniesQuery" v-on:keyup.enter="fetchCompanies();">
            <div class="input-group-append">
              <button class="btn btn-sm btn-primary" @click="fetchCompanies();" type="button">Search</button>
            </div>
          </div>
        </div> -->

        <div v-if="companiesTree.length > 0" class="mt-3">
          <company-card v-for="(company, index) in companiesTree" :key="index" 
          :company="company"
          :parent="(company.parentDto) ? companiesIndex[company.parentDto.id] : null"
          :is-editable="actions.canUpdateCompany"
          :is-deletable="actions.canDeleteCompany"
          :can-add-case="actions.canCreateCase"
          :can-edit-custom-topics="actions.canEditCustomTopics"
          @editCompanyClicked="handleEditCompanyClicked"
          @deleteCompanyClicked="handleDeleteCompanyClicked"
          @addCaseClicked="handleAddCaseClicked"
          @customTopicsClicked="handleCustomTopicsClicked"
          @logoClicked="handleLogoClicked">
          </company-card>
        </div>
        <div v-else class="mt-3">
          <div v-if="fetchingCompanies">Loading, please wait...</div>
          <div v-else class="text-center">No companies found</div>
        </div>

        <div class="form-group mt-3">
          <button :class="{btn:true, 'btn-sm':true, 'btn-default': true, 'cursor-forbidden':!actions.canCreateCompany}" style="color: #5F5C5C; background-color: #F5F5F5; border-radius: 5px; width: 100%; border: none;" @click="initCompanyModal(null)" :disabled="!actions.canCreateCompany">
            + add Company
          </button>
        </div>

      </div>
    </div>

    <modal name="company-modal" :draggable="true" height="auto" :scrollable="true" :clickToClose="false">
        <div style="position:relative;" class="p-3">
            <div style="position: absolute; top: 5px; right: 5px;">
              <button class="btn btn-sm btn-neutral btn-border" @click="$modal.hide('company-modal')">&times;</button>
            </div>
            <div>
              <h5 class="card-title mb-4" style="margin-top:5px;">Company Profile</h5>
            </div>
            <div>
              <div class="form-group">
                <label class="control-label" for="title_input">Title (full)*</label>
                <div v-if="company.id" class="input-group">
                  <input class="form-control" id="title_input" type="text" v-model.trim="company.title" required>
                  <div class="input-group-append">
                    <button class="btn btn-sm btn-secondary" type="button" @click="saveCompanyTitle" :disabled="savingCompany">Save</button>
                  </div>
                </div>
                <input v-else class="form-control" id="title_input" type="text" v-model.trim="company.title" required>
              </div>
              <div class="form-group">
                <label class="control-label" for="tradetitle_input">Trade Title (short)*</label>
                <div v-if="company.id" class="input-group">
                  <input class="form-control" id="tradetitle_input" type="text" v-model.trim="company.tradeTitle" required>
                  <div class="input-group-append">
                    <button class="btn btn-sm btn-secondary" type="button" @click="saveCompanyTradeTitle" :disabled="savingCompany">Save</button>
                  </div>
                </div>
                <input v-else class="form-control" id="tradetitle_input" type="text" v-model.trim="company.tradeTitle" required>
              </div>
              <div class="form-group">
                <label class="control-label" for="vatnumber_input">Tax Identification Number (TIN)*</label>
                <div v-if="company.id" class="input-group">
                  <input class="form-control" id="vatnumber_input" type="text" v-model.trim="company.vatNumber" required>
                  <div class="input-group-append">
                    <button class="btn btn-sm btn-secondary" type="button" @click="saveCompanyVatNumber" :disabled="savingCompany">Save</button>
                  </div>
                </div>
                <input v-else class="form-control" id="vatnumber_input" type="text" v-model.trim="company.vatNumber" required>
              </div>
              <div class="form-group">
                <label class="control-label" for="industry_input">Industry*</label>
                <div v-if="company.id">
                  <table style="width:100%;">
                    <tr>
                      <td>
                        <v-select id="industry_input" v-model="company.industryObject" :options="industriesFlat"></v-select>
                      </td>
                      <td style="width: 66px;">
                        <button class="btn btn-sm btn-secondary" type="button" @click="saveCompanyIndustry" :disabled="savingCompany">Save</button>
                      </td>
                    </tr>
                  </table>
                </div>
                <v-select v-else id="industry_input" v-model="company.industryObject" :options="industriesFlat"></v-select>
              </div>
              <div class="form-group">
                <label class="control-label" for="parent_input">Parent Company (company group)</label>
                <div v-if="company.id">
                  <table style="width:100%;">
                    <tr>
                      <td>
                        <v-select id="parent_input" v-model="company.parentObject" :options="parentCompanies"></v-select>
                      </td>
                      <td style="width: 66px;">
                        <button class="btn btn-sm btn-secondary" type="button" @click="saveCompanyParent" :disabled="savingCompany">Save</button>
                      </td>
                    </tr>
                  </table>
                </div>
                <v-select v-else id="parent_input" v-model="company.parentObject" :options="parentCompanies"></v-select>
              </div>
              <div class="form-group">
                <label class="control-label" for="country_input">Country*</label>
                <v-select id="country_input" v-model="selectedCountryObject" :options="countries" @input="fetchRegionsByCountry"></v-select>
              </div>
              <div class="form-group">
                <label class="control-label" for="region_input">Region*</label>
                <v-select id="region_input" v-model="selectedRegionObject" :options="regions" @input="fetchRegionalUnitsByRegion"></v-select>
              </div>
              <div class="form-group">
                <label class="control-label" for="regionalunit_input">Regional Unit (District)*</label>
                <div v-if="company.id">
                  <table style="width:100%;">
                    <tr>
                      <td>
                        <v-select id="regionalunit_input" v-model="company.regionalUnitObject" :options="regionalUnits"></v-select>
                      </td>
                      <td style="width: 66px;">
                        <button class="btn btn-sm btn-secondary" type="button" @click="saveCompanyRegionalUnit" :disabled="savingCompany">Save</button>
                      </td>
                    </tr>
                  </table>
                </div>
                <v-select v-else id="regionalunit_input" v-model="company.regionalUnitObject" :options="regionalUnits"></v-select>
              </div>
              <div class="form-group">
                <label class="control-label" for="address_input">Address*</label>
                <div v-if="company.id" class="input-group">
                  <input class="form-control" id="address_input" type="text" v-model.trim="company.address" required>
                  <div class="input-group-append">
                    <button class="btn btn-sm btn-secondary" type="button" @click="saveCompanyAddress" :disabled="savingCompany">Save</button>
                  </div>
                </div>
                <input v-else class="form-control" id="address_input" type="text" v-model.trim="company.address" required>
              </div>
              <div class="form-group">
                <label class="control-label" for="postalcode_input">Postal Code*</label>
                <div v-if="company.id" class="input-group">
                  <input class="form-control" id="postalcode_input" type="text" v-model.trim="company.postalCode" required>
                  <div class="input-group-append">
                    <button class="btn btn-sm btn-secondary" type="button" @click="saveCompanyPostalCode" :disabled="savingCompany">Save</button>
                  </div>
                </div>
                <input v-else class="form-control" id="postalcode_input" type="text" v-model.trim="company.postalCode" required>
              </div>
              <div class="form-group" style="display:none;">
                <div v-if="company.id">
                  <table style="width:100%;">
                    <tr>
                      <td>
                        <div class="form-check">
                          <input class="form-check-input" id="ispublic_input" type="checkbox" v-model.trim="company.isPublic" required>
                          <label class="form-check-label" for="ispublic_input">Public ESG Data</label>
                        </div>
                      </td>
                      <td style="width: 66px;">
                        <button class="btn btn-sm btn-secondary" type="button" @click="saveCompanyIsPublic" :disabled="savingCompany">Save</button>
                      </td>
                    </tr>
                  </table>
                </div>
                <div v-else class="form-check">
                  <input class="form-check-input" id="ispublic_input" type="checkbox" v-model.trim="company.isPublic" required>
                  <label class="form-check-label" for="ispublic_input">Public ESG Data</label>
                </div>
              </div>
              <div class="form-group d-none">
                <label class="control-label" for="share_data_input">Select banks to share company data</label>
                <div v-if="company.id">
                  <table style="width:100%;">
                    <tr>
                      <td>
                        <v-select multiple :append-to-body="true" :calculate-position="calculatePosition" id="share_data_input" v-model="selectedBanks" :options="banks"></v-select>
                      </td>
                      <td style="width: 66px;">
                        <button class="btn btn-sm btn-secondary" type="button" @click="saveSelectedBanks" :disabled="savingCompany">Save</button>
                      </td>
                    </tr>
                  </table>
                </div>
                <v-select v-else multiple :append-to-body="true" :calculate-position="calculatePosition" id="share_data_input" v-model="selectedBanks" :options="banks"></v-select>
              </div>
            </div>
            <hr>
            <div class="text-center">
              <button class="btn btn-neutral btn-border" @click="$modal.hide('company-modal')">Close</button>
              <button v-if="!company.id" class="btn btn-success ml-2" @click="createCompany" :disabled="savingCompany">Save<span v-if="savingCompany">...</span></button>
              <div v-if="saveCompanyErrorMsg !== ''" class="text-danger mt-1">{{ saveCompanyErrorMsg }}</div>
            </div>
        </div>
    </modal>

    <modal name="delete-company-modal" :draggable="false" height="auto" :scrollable="false" :clickToClose="false">
        <div style="position:relative;" class="p-3">
            <div style="position: absolute; top: 5px; right: 5px;">
              <button class="btn btn-sm btn-neutral btn-border" @click="$modal.hide('delete-company-modal')">&times;</button>
            </div>
            <div>
              <h5 class="card-title mb-4" style="margin-top:5px;">Are you sure you want to delete <i>{{ company.tradeTitle }}</i>?</h5>
            </div>
            <hr>
            <div class="text-center">
              <button class="btn btn-neutral btn-border" @click="$modal.hide('delete-company-modal')">No</button>
              <button class="btn btn-danger ml-2" @click="deleteCompany" :disabled="deletingCompany">Yes<span v-if="deletingCompany">...</span></button>
              <div v-if="deleteCompanyErrorMsg !== ''" class="text-danger mt-1">{{ deleteCompanyErrorMsg }}</div>
            </div>
        </div>
    </modal>

    <modal name="logo-modal" :draggable="true" height="auto" :scrollable="true" :clickToClose="false">
        <div style="position:relative;" class="p-3">
            <div style="position: absolute; top: 5px; right: 5px;">
              <button class="btn btn-sm btn-neutral btn-border" @click="$modal.hide('logo-modal');logoFile=null;">&times;</button>
            </div>
            <div>
              <h5 class="card-title mb-4" style="margin-top:5px;">Set logo for <i>{{ company.tradeTitle }}</i></h5>
            </div>
            <div class="form-group">
              <label>Select file
                <input type="file" @change="logoFile = $event.target.files[0];"/>
              </label>
            </div>
            <div class="form-group">
              <div class="pull-left">
                <button class="btn btn-sm btn-secondary" @click="saveCompanyLogo" :disabled="savingCompanyLogo">Upload<span v-if="savingCompanyLogo">...</span></button>
              </div>
              <div v-if="company.logoPath !== ''" class="pull-right">
                <a href="javascript:void(0);" @click="deleteCompanyLogo" :disabled="deletingCompanyLogo">remove existing logo<span v-if="deletingCompanyLogo">...</span></a>
              </div>
              <div style="clear:both;"></div>
            </div>
            <hr>
        </div>
    </modal>

    <modal name="case-modal" :draggable="true" height="auto" :scrollable="true" :clickToClose="false">
        <div style="position:relative;" class="p-3">
            <div style="position: absolute; top: 5px; right: 5px;">
              <button class="btn btn-sm btn-neutral btn-border" @click="$modal.hide('case-modal')">&times;</button>
            </div>
            <div>
              <h5 class="card-title mb-4" style="margin-top:5px;">New Year <i v-if="casee.companyId">{{ companiesIndex[casee.companyId].tradeTitle }}</i></h5>
            </div>
            <div>
              <div class="form-group">
                <label class="control-label" for="yearcase_input">Year*</label>
                <input class="form-control" id="yearcase_input" type="number" min="2020" :max="new Date().getFullYear()" v-model.trim="casee.year" required>
              </div>
              <div class="form-group">
                <label class="control-label" for="frameworks_input">Framework(s)*</label>
                <v-select multiple :append-to-body="true" id="frameworks_input" v-model="selectedFrameworks" :options="frameworks"></v-select>
              </div>
              <div class="form-group">
                <label class="control-label" for="numberofemployees_input">Total number of organization's employees</label>
                <input class="form-control" id="numberofemployees_input" type="number" min="0" step="1" v-model.trim="casee.numberOfEmployees" required>
              </div>
              <div class="form-group">
                <label class="control-label" for="turnover_input">Turnover (&euro;)</label>
                <input class="form-control" id="turnover_input" type="text" :value="casee.turnover" @input="casee.turnover = withThousandsSeparator(withoutThousandsSeparator($event.target.value.trim()))" required>
              </div>
              <div class="form-group">
                <label class="control-label" for="totalassets_input">Total Assets (&euro;)</label>
                <input class="form-control" id="totalassets_input" type="text" :value="casee.totalAssets" @input="casee.totalAssets = withThousandsSeparator(withoutThousandsSeparator($event.target.value.trim()))" required>
              </div>
              <div class="form-group" style="display:none;">
                <div class="form-check">
                  <input class="form-check-input" id="ispubliccase_input" type="checkbox" v-model.trim="casee.isPublic" required>
                  <label class="form-check-label" for="ispubliccase_input">Public ESG Data</label>
                </div>
              </div>
            </div>
            <hr>
            <div class="text-center">
              <button class="btn btn-neutral btn-border" @click="$modal.hide('case-modal')">Close</button>
              <button class="btn btn-success ml-2" @click="createCase" :disabled="savingCase">Save<span v-if="savingCase">...</span></button>
              <div v-if="saveCaseErrorMsg !== ''" class="text-danger mt-1">{{ saveCaseErrorMsg }}</div>
            </div>
        </div>
    </modal>
  </div>
</template>
<script>
import Api from "../api";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import CompanyCard from '../components/CompanyCard.vue';
export default {
  components: {
    vSelect,
    CompanyCard
  },
  data() {
    return {
      saveCompanyErrorMsg: "",
      saveCaseErrorMsg: "",
      deleteCompanyErrorMsg: "",
      savingCompany: false,
      savingCase: false,
      deletingCompany: false,
      sendingVerificationEmail: false,
      savingCompanyLogo: false,
      deletingCompanyLogo: false,

      companiesTree: [],
      latestCasesIndex: {},
      companiesIndex: {},
      
      company: {
        id: null,
        title: "",
        tradeTitle: "",
        vatNumber: "",
        industryObject: {code: null, label: 'Select Industry'},
        parentObject: {code: null, label: 'Select parent company'},
        address: "",
        postalCode: "",
        regionalUnitObject: {code: null, label: 'Select region first'},
        logoPath: "",
        isPublic: true
      },

      casee: {
        companyId: null,
        year: null,
        isPublic: true,
        numberOfEmployees: null,
        turnover: null,
        totalAssets: null
      },

      countries: [{code: null, label: 'Select Country'}],
      regions: [{code: null, label: 'Select country first'}],
      regionalUnits: [{code: null, label: 'Select region first'}],
      selectedCountryObject: {code: null, label: 'Select Country'},
      selectedRegionObject: {code: null, label: 'Select country first'},

      industriesFlat: [{code: null, label: 'Select Industry'}],
      parentCompanies: [{code: null, label: 'Select parent company'}],

      searchCompaniesQuery: "",

      actions: {
        canCreateCompany: this.$root.canUserDo(['company_create']),
        canUpdateCompany: this.$root.canUserDo(['company_update']),
        canDeleteCompany: this.$root.canUserDo(['company_delete']),
        canCreateCase: this.$root.canUserDo(['case_create']),
        canEditCustomTopics: this.$root.canUserDo(['custom_topic_update', 'custom_criterion_update']),
      },

      fetchingCompanies: true,
      logoFile: null,

      banks: [
        'Εurobank',
        'Alpha Bank',
        'Piraeus Bank',
        'National Bank of Greece',
        'Pancreta Bank',
        'Optima Bank',
        'Attica Bank',
      ],
      selectedBanks:[],
      frameworks: ['nza'],
      selectedFrameworks: [],
      pillars: ['environmental'],
      calculatePosition: function(dropdownList, component, {width, top, left}) {
        let topTmp = parseFloat(top.split('px').join(''));
        dropdownList.style.top = topTmp - 270 + 'px';
        dropdownList.style.left = left;
        dropdownList.style.width = width;
      }
    };
  },
  mounted() {
    this.fetchFrameworks();
  },
  methods: {

    initCompanyModal(companyId) {
      if (companyId) {
        this.resetCompany();
        this.company.id = parseInt(companyId);
        this.fetchCompany();
      } else {
        this.resetCompany();
      }
      this.saveCompanyErrorMsg = "";
      this.$modal.show('company-modal');
    },

    initLogoModal(company) {
      this.logoFile = null;
      this.resetCompany();
      this.company.id = parseInt(company.id);
      this.company.tradeTitle = company.tradeTitle;
      this.company.logoPath = company.logoPath;
      this.$modal.show('logo-modal');
    },

    initCaseModal(companyId, isPublic) {
      if (!companyId) {
        return false;
      }
      this.resetCase();
      this.saveCaseErrorMsg = "";
      this.casee.companyId = parseInt(companyId);
      this.casee.isPublic = isPublic;
      if (this.latestCasesIndex[companyId]) {
        this.casee.year = parseInt(this.latestCasesIndex[companyId].year) + 1;
      } else {
        this.casee.year = parseInt(new Date().getFullYear()) - 1;
      }
      this.$modal.show('case-modal');
    },

    initDeleteCompanyModal(companyId, tradeTitle) {
      if (!companyId) {
        return false;
      }
      this.deleteCompanyErrorMsg = "";
      this.resetCompany();
      this.company.id = parseInt(companyId);
      this.company.tradeTitle = tradeTitle;
      this.$modal.show('delete-company-modal');
    },

    resetCompany() {
        this.company.id = null;
        this.company.title = "";
        this.company.tradeTitle = "";
        this.company.vatNumber = "";
        this.company.industryObject = {code: null, label: 'Select Industry'};
        this.company.parentObject = {code: null, label: 'Select parent company'};
        this.company.address = "";
        this.company.postalCode = "";
        this.company.regionalUnitObject = {code: null, label: 'Select region first'};
        this.company.logoPath = "";
        this.company.isPublic = true;

        this.selectedBanks = [];
    },

    resetCase() {
        this.casee.companyId = null;
        this.casee.year = null;
        this.casee.isPublic = true;
        this.casee.numberOfEmployees = null;
        this.casee.turnover = null;
        this.casee.totalAssets = null;
    },

    sendVerificationEmail() {
      if (this.sendingVerificationEmail) {
        return false;
      }
      if (confirm('You will be logged out for security reasons and then we will send you the link to verify your email address. Do you want to proceed?')) {
        this.sendingVerificationEmail = true;
        let self = this;
        Api.send("POST", "/user/verify/email/send", {}, false)
        .then((response) => {
          self.$root.deleteLoggedUser();
          self.$router.push({path:'verify_email_send_success'})
        })
        .catch((err) => {
          self.$root.notifyy('danger', err.msg);
        })
        .finally(() => {
          this.sendingVerificationEmail = false;
        });
      }
    },

    fetchFrameworks() {
      let self = this;
      Api.send('GET', '/frameworks', {}, false)
      .then((response) => {
        self.frameworks = response;
        self.fetchPillars();
      })
      .catch((err) => {
        
      });
    },
    fetchPillars() {
      let self = this;
      Api.send('GET', '/pillars', {}, false)
      .then((response) => {
        self.pillars = response;
        self.fetchUserInfo();
      })
      .catch((err) => {
        
      });
    },

    fetchCompany() {
      let self = this;
      Api.send("GET", "/companies/" + self.company.id + "?with_industry=1&with_full_region_info=1&with_parent=1", {})
        .then((response) => {
          self.company.title = response.title;
          self.company.tradeTitle = response.tradeTitle;
          self.company.vatNumber = response.vatNumber;
          self.company.industryObject.code = response.industryDto.id;
          self.company.industryObject.label = "(" + response.industryDto.naceCode + ") " + response.industryDto.title;
          self.company.parentObject.code = (response.parentDto) ? response.parentDto.id : null;
          self.company.parentObject.label = (response.parentDto) ? response.parentDto.tradeTitle : 'Select parent company';
          self.company.address = response.addressDto.address;
          self.company.postalCode = response.addressDto.postalCode;
          self.company.regionalUnitObject.code = response.addressDto.regionalUnitDto.id;
          self.company.regionalUnitObject.label = response.addressDto.regionalUnitDto.title;
          self.company.logoPath = response.logoPath;
          self.company.isPublic = response.isPublic;
        })
        .catch((err) => {
          self.resetCompany();
        })
        .finally(() => {
          
        });
    },

    fetchCompanies() {
      let self = this;
      self.parentCompanies = [{code: null, label: 'Select parent company'}];
      self.fetchingCompanies = true;
      Api.send("GET", "/companies?page=1&per_page=50&query=" + self.searchCompaniesQuery, {})
        .then((response) => {
          self.latestCasesIndex = {};
          for(let j in response.latestCases) {
            let latestCase = response.latestCases[j];
            self.latestCasesIndex[latestCase.companyId] = latestCase;
          }

          let tempCompanies = response.data;
          self.companiesIndex = {};
          let map = {}, node, res = [], i;

          for (i = 0; i < tempCompanies.length; i ++) {
            let rowId = tempCompanies[i].id;
            map[rowId] = i;
            if (self.latestCasesIndex[rowId]) {
              tempCompanies[i]['latestCase'] = self.latestCasesIndex[rowId];
            } else {
              tempCompanies[i]['latestCase'] = null;
            }
            self.parentCompanies.push({
              code: rowId,
              label: tempCompanies[i].tradeTitle
            });
            self.companiesIndex[rowId] = tempCompanies[i];
          };
          for (i = 0; i < tempCompanies.length; i ++) {
              node = tempCompanies[i];
              if (node.parentDto) {
                tempCompanies[map[node.parentDto.id]].childrenCompanyDtos.push(node);
              } else {
                res.push(node);
              };
          };

          self.companiesTree = res;
        })
        .catch((err) => {
          self.companiesTree = [];
        })
        .finally(() => {
          self.fetchingCompanies = false;
        });
    },

    fetchUserInfo() {
      let self = this;
      Api.send("GET", "/user/basic_info", {}, false)
        .then((response) => {
          let loggedUser = self.$root.getLoggedUser();
          loggedUser.has_verified_email = response.data.hasVerifiedEmail;
          loggedUser.is_verified = response.data.isVerified;
          self.$root.setLoggedUser(loggedUser);
          if (!response.data.hasVerifiedEmail) {
            self.actions.canCreateCompany = false;
            self.actions.canUpdateCompany = false;
            self.actions.canDeleteCompany = false;
            self.actions.canCreateCase = false;
            self.actions.canEditCustomTopics = false;
          }
          this.fetchCompanies();
          this.fetchCountries();
        })
        .catch((err) => {
          self.$root.deleteLoggedUser();
          self.$router.push({name: 'login'});
        })
        .finally(() => {
          
        });
    },

    fetchIndustriesTree() {
      let self = this;
      Api.send('GET', '/industries/all/tree', {})
      .then((response) => {
        self.registerIndustriesFlat(response);
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      });
    },

    registerIndustriesFlat(industriesTree) {
      for (let i in industriesTree) {
        this.registerChildren(industriesTree[i], '');
      }
    },

    registerChildren(item, prefix) {
      let title = prefix;
      if (item.naceCode && item.naceCode !== '') {
        title += '(' + item.naceCode + ') ';
      }
      title += item.title;
      this.industriesFlat.push({
        code: item.id,
        label: title
      });
      if (item.childrenDtos.length > 0) {
        for (let i in item.childrenDtos) {
          this.registerChildren(item.childrenDtos[i], prefix + '')
        }
      }
    },

    fetchCountries() {
      let self = this;
      self.countries = [{code: null, label: 'Select Country'}];
      Api.send('GET', '/countries', {})
      .then((response) => {
        for(let i in response) {
          self.countries.push({
            code: response[i]['id'],
            label: response[i]['title']
          });
        }
        self.fetchIndustriesTree();
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      });
    },

    fetchRegionsByCountry() {
      let self = this;
      self.regions = [{code: null, label: 'Select country first'}];
      self.regionalUnits = [{code: null, label: 'Select region first'}];
      self.selectedRegionObject = {code: null, label: 'Select country first'};
      self.company.regionalUnitObject = {code: null, label: 'Select region first'};
      if (!self.selectedCountryObject || !self.selectedCountryObject.code) {
        return false;
      }
      Api.send('GET', '/regions?country_id=' + self.selectedCountryObject.code, {})
      .then((response) => {
        for(let i in response) {
          self.regions.push({
            code: response[i]['id'],
            label: response[i]['title']
          });
        }
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      });
    },

    fetchRegionalUnitsByRegion() {
      let self = this;
      self.regionalUnits = [{code: null, label: 'Select region first'}];
      self.company.regionalUnitObject = {code: null, label: 'Select region first'};
      if (!self.selectedRegionObject || !self.selectedRegionObject.code) {
        return false;
      }
      Api.send('GET', '/regional_units?region_id=' + self.selectedRegionObject.code, {})
      .then((response) => {
        for(let i in response) {
          self.regionalUnits.push({
            code: response[i]['id'],
            label: response[i]['title']
          });
        }
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      });
    },

    createCompany() {
      let self = this;
      self.saveCompanyErrorMsg = "";
      self.savingCompany = true;
      Api.send('POST', '/companies', {
        title: self.company.title,
        tradeTitle: self.company.tradeTitle,
        vatNumber: self.company.vatNumber,
        industryId: self.company.industryObject.code,
        parentId: self.company.parentObject.code,
        address: self.company.address,
        postalCode: self.company.postalCode,
        regionalUnitId: self.company.regionalUnitObject.code,
        isPublic: self.company.isPublic
      })
      .then((response) => {
        self.fetchCompanies();
        self.$modal.hide('company-modal');
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.saveCompanyErrorMsg = err.msg;
      })
      .finally(() => {
        self.savingCompany = false;
      });
    },

    createCase() {
      let self = this;
      self.saveCaseErrorMsg = "";
      self.savingCase = true;
      Api.send('POST', '/cases', {
        companyId: self.casee.companyId,
        year: self.casee.year,
        isPublic: self.casee.isPublic,
        numberOfEmployees: self.casee.numberOfEmployees,
        turnover: self.withoutThousandsSeparator(self.casee.turnover),
        totalAssets: self.withoutThousandsSeparator(self.casee.totalAssets),
        frameworks: self.selectedFrameworks
      })
      .then((response) => {
        self.fetchCompanies();
        self.$modal.hide('case-modal');
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.saveCaseErrorMsg = err.msg;
      })
      .finally(() => {
        self.savingCase = false;
      });
    },

    deleteCompany() {
      let self = this;
      if (!self.company.id) {
        return false;
      }
      self.deletingCompany = true;
      self.deleteCompanyErrorMsg = "";
      Api.send('DELETE', '/companies/' + self.company.id, {})
      .then((response) => {
        self.fetchCompanies();
        self.$modal.hide('delete-company-modal');
        self.resetCompany();
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.deleteCompanyErrorMsg = err.msg;
      })
      .finally(() => {
        self.deletingCompany = false;
      });
    },

    saveCompanyTitle() {
      let self = this;
      if (!self.company.id) {
        return false;
      }
      self.savingCompany = true;
      Api.send('PATCH', '/companies/' + self.company.id + '/title', {title: self.company.title})
      .then((response) => {
        self.fetchCompanies();
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      })
      .finally(() => {
        self.savingCompany = false;
      });
    },

    saveCompanyTradeTitle() {
      let self = this;
      if (!self.company.id) {
        return false;
      }
      self.savingCompany = true;
      Api.send('PATCH', '/companies/' + self.company.id + '/trade_title', {tradeTitle: self.company.tradeTitle})
      .then((response) => {
        self.fetchCompanies();
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      })
      .finally(() => {
        self.savingCompany = false;
      });
    },

    saveCompanyVatNumber() {
      let self = this;
      if (!self.company.id) {
        return false;
      }
      self.savingCompany = true;
      Api.send('PATCH', '/companies/' + self.company.id + '/vat_number', {vatNumber: self.company.vatNumber})
      .then((response) => {
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      })
      .finally(() => {
        self.savingCompany = false;
      });
    },

    saveCompanyIndustry() {
      let self = this;
      if (!self.company.id) {
        return false;
      }
      self.savingCompany = true;
      Api.send('PATCH', '/companies/' + self.company.id + '/industry', {industryId: self.company.industryObject.code})
      .then((response) => {
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      })
      .finally(() => {
        self.savingCompany = false;
      });
    },

    saveCompanyParent() {
      let self = this;
      if (!self.company.id) {
        return false;
      }
      self.savingCompany = true;
      Api.send('PATCH', '/companies/' + self.company.id + '/parent', {parentId: self.company.parentObject.code})
      .then((response) => {
        self.fetchCompanies();
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      })
      .finally(() => {
        self.savingCompany = false;
      });
    },

    saveCompanyAddress() {
      let self = this;
      if (!self.company.id) {
        return false;
      }
      self.savingCompany = true;
      Api.send('PATCH', '/companies/' + self.company.id + '/address', {address: self.company.address})
      .then((response) => {
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      })
      .finally(() => {
        self.savingCompany = false;
      });
    },

    saveCompanyPostalCode() {
      let self = this;
      if (!self.company.id) {
        return false;
      }
      self.savingCompany = true;
      Api.send('PATCH', '/companies/' + self.company.id + '/postal_code', {postalCode: self.company.postalCode})
      .then((response) => {
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      })
      .finally(() => {
        self.savingCompany = false;
      });
    },

    saveCompanyRegionalUnit() {
      let self = this;
      if (!self.company.id) {
        return false;
      }
      self.savingCompany = true;
      Api.send('PATCH', '/companies/' + self.company.id + '/regional_unit', {regionalUnitId: self.company.regionalUnitObject.code})
      .then((response) => {
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      })
      .finally(() => {
        self.savingCompany = false;
      });
    },

    saveCompanyIsPublic() {
      let self = this;
      if (!self.company.id) {
        return false;
      }
      self.savingCompany = true;
      Api.send('PATCH', '/companies/' + self.company.id + '/is_public', {isPublic: self.company.isPublic})
      .then((response) => {
        self.fetchCompanies();
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      })
      .finally(() => {
        self.savingCompany = false;
      });
    },

    saveCompanyLogo() {
      let self = this;
      if (!self.company.id || !self.logoFile) {
        return false;
      }

      self.savingCompanyLogo = true;
      let formData = new FormData();
      formData.append('logo', self.logoFile);

      const baseUrl = Api.getBaseUrl(true);
      const url = '/companies/' + self.company.id + '/logo';
      const loggedUser = self.$root.getLoggedUser();
      const token = (loggedUser) ? loggedUser.token : "";

      let xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function() {
        if (this.readyState == 4) {
          const json = (this.responseText) ? JSON.parse(this.responseText) : null;
          if (this.status == 200) {
              self.fetchCompanies();
              self.$root.notifyy('success', json.msg);
              self.logoFile = null;
              self.$modal.hide('logo-modal');
          } else {
              if (this.status == 401) {
                  self.$root.deleteLoggedUser();
                  location.reload();
              }
              self.$root.notifyy('danger', json.msg);
          }
          self.savingCompanyLogo = false;
        }
      };
      xhttp.open('POST', baseUrl + url, true);
      xhttp.setRequestHeader('Bearer-Token', token);
      xhttp.setRequestHeader('Accept', 'application/json');
      xhttp.send(formData);    
    },

    saveSelectedBanks() {
      let self = this;
      setTimeout(function() {
        self.$root.notifyy('success', 'Your changes have been saved');
      }, 500)
    },

    deleteCompanyLogo() {
      let self = this;
      if (!self.company.id) {
        return false;
      }
      self.deletingCompanyLogo = true;
      Api.send('DELETE', '/companies/' + self.company.id + '/logo', {})
      .then((response) => {
        self.fetchCompanies();
        self.$root.notifyy('success', response.msg);
        self.logoFile = null;
        self.$modal.hide('logo-modal');
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      })
      .finally(() => {
        self.deletingCompanyLogo = false;
      });
    },

    handleEditCompanyClicked (item) {
      this.initCompanyModal(item.id);
    },
    handleDeleteCompanyClicked (item) {
      this.initDeleteCompanyModal(item.id, item.tradeTitle);
    },
    handleCustomTopicsClicked (item) {
      this.$router.push({path:'/custom_topics/' + item.id});
    },
    handleAddCaseClicked (item) {
      this.initCaseModal(item.id, item.isPublic);
    },
    handleLogoClicked (item) {
      this.initLogoModal(item);
    },

    withThousandsSeparator(number) {
      if (number === null || number === '') {
        return null;
      }
      return number.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
    },
    withoutThousandsSeparator(number) {
      if (number === null || number === '') {
        return null;
      }
      return parseFloat(number.replace(/,/g, ''));
    },

  }
};
</script>
<style scoped>
.cursor-forbidden {
  cursor: not-allowed;
}
.btn-neutral {
  border-radius: 0px;
  padding-right: 30px;
  padding-left: 30px;
  border-radius: none;
}        
.btn-neutral:hover {
  background-color: white;   
  color: #717171;
  border: 2px solid black;
}
.pointer {
  cursor: pointer;
}
</style>
